import React  , {useState} from "react"
import { Row, Col } from "react-bootstrap"
import EachSong from "./eachsong"
import { graphql, StaticQuery , Link } from "gatsby"
import {GoTriangleRight} from "react-icons/go"
import "../../Styles/musicsecs.scss"
export default function Suggestions() {
  const [btnhover4 , setbtnhover4] = useState(false)
  return (
    <div>
      <Row>
      <Col md="12" className="music-sec-titles">
        <h1>HONOTE SUGGESTIONS</h1>
        <Link to="././suggestion">
        <span className={btnhover4 ? "badge-hover badge" :"badge" }
        onMouseEnter={() => {
          setbtnhover4(true)
      }}
      onMouseLeave={() => {
        setbtnhover4(false)
      }}
      > 
          <ul>
            <li>
              <small>
                <GoTriangleRight />
              </small>
            </li>
            <li>
            <small>
                Load more
              </small>
            </li>
          </ul>
          <small>

          </small>
        </span></Link>
        <div className="div1">
          <div className="div2"></div>
        </div>
      </Col></Row>
      <div className="scroll-container">
      <StaticQuery
        query={topmusic}
        render={data => {
          return (
           
      <Row>
              {data.allMarkdownRemark.edges.map(({ node }) => (
                <Col xs={6} sm={4} md={3} lg={2}>
                  <EachSong
                    key={node.id}
                    title={node.frontmatter.title}
                    artist={node.frontmatter.artist}
                    date={node.frontmatter.date}
                    slug={node.fields.slug}
                    fluid={node.frontmatter.image.childImageSharp.fluid}
                  />
               </Col>
              ))}
            </Row>
          )
        }}
      /></div>
    </div>
  )
}

const topmusic = graphql`
  query {
    allMarkdownRemark(
      sort: { fields: [frontmatter___rate], order: DESC }
      limit: 6
      filter: { frontmatter: { cat: { eq: "music" } } }
    ) {
      edges {
        node {
          id
          frontmatter {
            title
            date
            rate
            image {
              childImageSharp {
                fluid(maxWidth: 900) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
            artist
          }

          fields {
            slug
          }
        }
      }
    }
  }
`
